import React, { Fragment } from "react";
import Moment from "react-moment";

const MessageUserListItem = ({
  message,
  setUserObject,
  deleteConversation,
}) => {
  return (
    <Fragment>
      {message.role === "innovator" && message.messages.length > 0 && (
        <div
          className="message-user-container unread-messages"
          onClick={() =>
            setUserObject({
              user: message.user,
              channelid: message.channelid,
              role: message.role,
              avatar: message.avatar,
              firstname: message.firstname,
              lastname: message.lastname,
              companyname: message.companyname,
              jobtitle: message.jobtitle,
              location: message.location,
              messages: message.messages ? [...message.messages] : [],
            })
          }
        >
          <i
            className="fas fa-times fa-sm message-delete green"
            onClick={() => {
              deleteConversation(message.user);
            }}
          ></i>
          <div className="message-list-avi-container">
            <p className="message-list-count">5</p>
            <div className="avi-color-border green">
              <img
                alt="avatar"
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                  message.messages && message.messages.at(-1).recipientavatar
                }`}
                className="message-list-avi"
              />
            </div>
          </div>
          <div className="message-list-preview">
            {message.messages.at(-1).image !== "" && (
              <p className="message-list-text">
                <i className="fas fa-photo-video fa-2x green"></i>
              </p>
            )}
            {message.messages.at(-1).video !== "" && (
              <p className="message-list-text">
                <i className="fas fa-photo-video fa-2x green"></i>
              </p>
            )}
            {message.messages.at(-1).gif !== "" && (
              <p className="message-list-text">{message.messages.at(-1).gif}</p>
            )}
            <p className="message-list-text">{message.messages.at(-1).text}</p>
            <div className="message-date-container white">
              <i className="far fa-clock message-date green"></i>
              <Moment format="LLLL">
                {message.messages && message.messages.at(-1).date}
              </Moment>
            </div>
            <p className="all-messages green">Click to view all messages</p>
          </div>
        </div>
      )}
      {message.role === "mentor" && message.messages.length > 0 && (
        <div
          className="message-user-container unread-messages"
          onClick={() =>
            setUserObject({
              user: message.user,
              channelid: message.channelid,
              role: message.role,
              avatar: message.avatar,
              firstname: message.firstname,
              lastname: message.lastname,
              companyname: message.companyname,
              jobtitle: message.jobtitle,
              location: message.location,
              messages: message.messages ? [...message.messages] : [],
            })
          }
        >
          <i className="fas fa-times fa-sm message-delete red"></i>
          <div className="message-list-avi-container">
            <p className="message-list-count">5</p>
            <div className="avi-color-border red">
              <img
                alt="message-avatar"
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                  message.messages && message.messages.at(-1).recipientavatar
                }`}
                className="message-list-avi"
              />
            </div>
          </div>
          <div className="message-list-preview">
            {message.messages.at(-1).image !== "" && (
              <p className="message-list-text">
                <i className="fas fa-photo-video fa-2x red"></i>
              </p>
            )}
            {message.messages.at(-1).video !== "" && (
              <p className="message-list-text">
                <i className="fas fa-photo-video fa-2x red"></i>
              </p>
            )}
            {message.messages.at(-1).gif !== "" && (
              <p className="message-list-text">{message.messages.at(-1).gif}</p>
            )}
            <p className="message-list-text">{message.messages.at(-1).text}</p>
            <div className="message-date-container white">
              <i className="far fa-clock message-date red"></i>
              <Moment format="LLLL">
                {message.messages && message.messages.at(-1).date}
              </Moment>
            </div>
            <p className="all-messages red">Click to view all messages</p>
          </div>
        </div>
      )}
      {message.role === "employer" && message.messages.length > 0 && (
        <div
          className="message-user-container unread-messages"
          onClick={() =>
            setUserObject({
              user: message.user,
              channelid: message.channelid,
              role: message.role,
              avatar: message.avatar,
              firstname: message.firstname,
              lastname: message.lastname,
              companyname: message.companyname,
              jobtitle: message.jobtitle,
              location: message.location,
              messages: message.messages ? [...message.messages] : [],
            })
          }
        >
          <i className="fas fa-times fa-sm message-delete blue"></i>
          <div className="message-list-avi-container">
            <p className="message-list-count">5</p>
            <div className="avi-color-border blue">
              <img
                alt="upload-avatar"
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                  message.messages && message.messages.at(-1).recipientavatar
                }`}
                className="message-list-avi"
              />
            </div>
          </div>
          <div className="message-list-preview">
            {message.messages.at(-1).image !== "" && (
              <p className="message-list-text">
                <i className="fas fa-photo-video fa-2x blue"></i>
              </p>
            )}
            {message.messages.at(-1).video !== "" && (
              <p className="message-list-text">
                <i className="fas fa-photo-video fa-2x blue"></i>
              </p>
            )}
            {message.messages.at(-1).gif !== "" && (
              <p className="message-list-text">{message.messages.at(-1).gif}</p>
            )}
            <p className="message-list-text">{message.messages.at(-1).text}</p>
            <div className="message-date-container white">
              <i className="far fa-clock message-date blue"></i>
              <Moment format="LLLL">
                {message.messages && message.messages.at(-1).date}
              </Moment>
            </div>
            <p className="all-messages blue">Click to view all messages</p>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default MessageUserListItem;
